import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_LIST_AUTHORIZATION_TRANSACTIONS_QUERY = gql`
  query authorizations($params: AuthorizationInput!) {
    authorizations(params: $params) {
      authorizations {
        id
        type
        status
        direction
        summary
        amount {
          amount
          currency
          formattedAmount
        }
        merchant
        paymentMethod
        recurring
        createdAt
        # new attributes
        cardId
        digitalWallet
        ecommerce
        verificationMethod
        merchantName
        merchantLocation
        merchantCategory
        currencyConversion {
          originalCurrency
          amountInOriginalCurrency
          fxRate
        }
        declineReason
        cardLast4Digits
      }
    }
  }
`;
